import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Box,
  Stack,
  Typography,
  Grid,
  Button,
  Menu,
  IconButton,
} from "@mui/material";
import { IoMdArrowDropdown } from "react-icons/io";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React from "react";
import moment from "moment";
import { connect } from "react-redux";
import {
  setShowEmailList,
  setselectedMail,
  setMailType,
  ApprovelEmail,
} from "../../../../../Redux/Actions/actions";
import {
  fileTypeToIconNeMail,
  formatFileSize,
} from "../../../../Utils/Email-utils/email-utils";
import parse from "html-react-parser";
import { CheckFat } from "@phosphor-icons/react";
import { Badge } from "@mui/base";

const mapStateToProps = (state) => {
  return {
    showEmailList: state.email.showEmailList,
  };
};

const EmailBodyForward = (props) => {
  const { mail } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const emailBody = parse(mail.emailBodyHtml, {
    replace: (domNode) => {
      if (
        domNode.type === "tag" &&
        domNode.name === "a" &&
        domNode.attribs.href
      ) {
        return (
          <a
            href={domNode.attribs.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {domNode.children[0].data}
          </a>
        );
      }
      return undefined;
    },
  });
  return (
    <Accordion
      sx={{
        "&.MuiAccordion-root": {
          marginBottom: "2px",
          background: "#f9f9f9",
          fontSize: "13px",
          boxShadow: "none",
          width: "100%",
        },
      }}
    >
      <AccordionSummary aria-controls="panel1-content" id="panel1-header">
        <Stack direction={"row"} spacing={1} sx={{ width: "100%" }}>
          {/* Avatar */}
          <Box>
            <Badge
              overlap="circular"
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              badgeContent={
                <Avatar
                  className="box-inset2"
                  sx={{
                    background: "green",
                    fontWeight: 600,
                    fontSize: "14px",
                    width: "13px",
                    height: "13px",
                  }}
                >
                  <CheckFat size={8} weight="fill" />
                </Avatar>
              }
            >
              <Avatar
                className="box-inset2"
                sx={{
                  background: mail.status == "Replied" ? "" : "#0B3363",
                  fontWeight: 600,
                  fontSize: "14px",
                }}
              >
                {mail ? mail.fromList.slice(0, 2).toUpperCase() : "UK"}
              </Avatar>
            </Badge>
          </Box>

          <Box sx={{ width: "100%" }}>
            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Stack spacing={0.2}>
                <Typography
                  variant="caption2"
                  sx={{ maxWidth: "300px", fontSize: "13px" }}
                  noWrap
                >
                  <h6 style={{ fontSize: "13px", marginBottom: "0" }}>
                    {mail.subject}{" "}
                  </h6>
                </Typography>
                <Stack direction="row" spacing={2}>
                  <Stack>
                    <Typography
                      className="text-muted"
                      variant="h6"
                      sx={{
                        userSelect: "text",
                        maxWidth: "250px",
                        fontSize: "12px",
                      }}
                      noWrap
                    >
                      From: {mail.fromList},
                    </Typography>
                  </Stack>
                  <Stack className="ms-1">
                    <Typography
                      variant="h6"
                      className="text-muted"
                      sx={{
                        userSelect: "text",
                        maxWidth: "150px",
                        fontSize: "12px",
                      }}
                      noWrap
                    >
                      {moment(mail.receivedTime).format("lll")}
                    </Typography>
                  </Stack>
                  <Stack></Stack>
                </Stack>
              </Stack>
            </Stack>
          </Box>
        </Stack>
      </AccordionSummary>

      <AccordionDetails className="border-bottom p-2 box-inset2">
        <Stack spacing={1} className=" p-2 mb-2" sx={{ background: "white" }}>
          <Stack>
            {/* subjecl  */}
            <Typography
              variant="caption2"
              sx={{ maxWidth: "300px", fontSize: "13px" }}
              noWrap
            >
              <h6 style={{ fontSize: "13px", marginBottom: "0" }}>
                {mail.subject}{" "}
              </h6>
            </Typography>
            {/* tome  */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <Typography className="fs-13 text-secondary me-1">
                to me{" "}
              </Typography>
              <IconButton
                onClick={handleClick}
                size="small"
                aria-controls={open ? "account-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
              >
                <IoMdArrowDropdown />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&::before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <Box onClick={handleClose} className="p-2">
                  <Box>
                    <table className="table fs-13 table-borderless">
                      <tbody>
                        <tr>
                          <th scope="row">From :</th>
                          <td
                            className="text-wrap text-break"
                            style={{
                              maxWidth: "300px",
                              textWrap: "balance",
                              overflow: "hidden",
                            }}
                          >
                            {" "}
                            {mail.fromList}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">Sent :</th>
                          <td
                            className="text-wrap text-break"
                            style={{
                              maxWidth: "300px",
                              textWrap: "balance",
                              overflow: "hidden",
                            }}
                          >
                            {" "}
                            {moment(mail.receivedTime).format(
                              "MMMM Do YYYY, h:mm:ss a"
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">To :</th>
                          <td
                            colspan="2"
                            className="text-wrap text-break"
                            style={{
                              maxWidth: "300px",
                              textWrap: "balance",
                              overflow: "hidden",
                            }}
                          >
                            {mail.toList}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">Cc :</th>
                          <td
                            colspan="2"
                            className="text-wrap text-break"
                            style={{
                              maxWidth: "300px",
                              textWrap: "balance",
                              overflow: "hidden",
                            }}
                          >
                            {/* {mail.ccList.length > 0 ? (
                              mail.ccList.map((item) => (
                                <>{item.emailAddress.address}</>
                              ))
                            ) : null} */}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">Bcc :</th>
                          <td
                            colspan="2"
                            className="text-wrap text-break"
                            style={{
                              textWrap: "balance",
                              maxWidth: "300px",
                              overflow: "hidden",
                            }}
                          >
                            {/* {mail.bccList.length > 0 ? (
                              mail.bccList.map((item) => (
                                <>{item.emailAddress.address}</>
                              ))
                            ) : null} */}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Box>
                </Box>
              </Menu>
            </Box>
            {/* emailBody */}
            <Box className="mt-2">{emailBody}</Box>
          </Stack>

          {mail.attachments.length > 0 && (
            <Grid xs={12} item>
              <Grid container direction="row">
                <Grid md={2} sm={2} item>
                  <Button
                    variant="outlined"
                    disableRipple
                    sx={{
                      padding: "0px 3px",
                      minWidth: "max-content",
                      borderRadius: "0px",
                      borderColor: "gray",
                      border: "none",
                      textTransform: "none",
                      fontSize: "12px",
                      color: "#7a7a7a",
                      cursor: "default !important",
                      "&:hover": {
                        border: "none",
                        background: "none",
                      },
                    }}
                  >
                    Attachment
                  </Button>
                </Grid>

                <Grid md={10} sm={10} item>
                  <div className="attachment-container">
                    {mail.attachments.length > 0
                      ? mail.attachments.map((data, index) => {
                          const icon = fileTypeToIconNeMail[data.extension];
                          return (
                            <Box
                              sx={{
                                width: "max-content",
                                border: "1px solid #cfcfcf",
                                padding: "5px",
                                fontSize: "13px",
                              }}
                              key={index}
                            >
                              <Stack
                                direction={"row"}
                                alignItems={"center"}
                                spacing={0.5}
                              >
                                <img
                                  src={icon}
                                  alt="File Icon"
                                  width="20px"
                                  height="20px"
                                />
                                <Stack spacing={0.4}>
                                  <Typography
                                    variant="caption"
                                    noWrap
                                    sx={{ width: "100px", fontSize: "13px" }}
                                  >
                                    <a href=""></a>
                                    {data.filename}
                                  </Typography>
                                  <div className="file-size">
                                    {formatFileSize(data.filesize)}
                                  </div>
                                </Stack>
                                <div className="dropdown-icon">
                                  <CaretDown
                                    color="#b2b2b2"
                                    ref={(el) =>
                                      (anchorRef.current[index] = el)
                                    }
                                    aria-controls={
                                      AttachmentPop[index]
                                        ? "split-button-menu"
                                        : undefined
                                    }
                                    aria-expanded={
                                      AttachmentPop[index] ? "true" : undefined
                                    }
                                    aria-label="select merge strategy"
                                    aria-haspopup="menu"
                                    onClick={() => handleToggle(index)}
                                    className={
                                      AttachmentPop[index]
                                        ? "rotate-90"
                                        : "rotate-0"
                                    }
                                  />

                                  <Popper
                                    sx={{
                                      zIndex: 1,
                                      marginTop: "10px !important",
                                    }}
                                    open={AttachmentPop[index]}
                                    anchorEl={anchorRef.current[index]}
                                    role={undefined}
                                    transition
                                    disablePortal
                                  >
                                    {({ TransitionProps, placement }) => (
                                      <Grow
                                        {...TransitionProps}
                                        style={{
                                          transformOrigin:
                                            placement === "bottom"
                                              ? "center top"
                                              : "center bottom",
                                        }}
                                      >
                                        <Paper sx={{ borderRadius: "0px" }}>
                                          <ClickAwayListener
                                            onClickAway={(event) =>
                                              sendhandleClose(event, index)
                                            }
                                          >
                                            <MenuList
                                              id="split-button-menu"
                                              autoFocusItem
                                              sx={{
                                                paddingTop: "0px",
                                                paddingBottom: "0px",
                                              }}
                                            >
                                              {["Preview", "Download"].map(
                                                (item, ind) => (
                                                  <MenuItem
                                                    sx={{
                                                      paddingLeft: "10px",
                                                      paddingRight: "40px",
                                                      fontSize: "12px",
                                                    }}
                                                    key={ind}
                                                    disabled={ind === 2}
                                                    selected={
                                                      ind === selectedIndex
                                                    }
                                                    onClick={(event) =>
                                                      handleMenuItemClick(
                                                        ind,
                                                        item,
                                                        data
                                                      )
                                                    }
                                                  >
                                                    {item}
                                                  </MenuItem>
                                                )
                                              )}
                                            </MenuList>
                                          </ClickAwayListener>
                                        </Paper>
                                      </Grow>
                                    )}
                                  </Popper>
                                </div>
                              </Stack>
                            </Box>
                          );
                        })
                      : null}
                  </div>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};
export default connect(mapStateToProps, {
  setShowEmailList,
  setselectedMail,
  setMailType,
  ApprovelEmail,
})(EmailBodyForward);
